<template>
  <hic-dialog append-to-body @open="loadData" :close-on-click-modal="false" :title="type" :visible="visible" width="44rem" top="10vh" @close="close">
    <el-scrollbar style="height: 40rem">
      <hic-print-simple :tmpl-code="tmplCode" :print-data="printData" ref="printer">
        <template #tools>
          <b class="sub-title">{{ hospitalization.patientName }} {{ hospitalization.bedNo }}床 {{ hospitalization.patientAge }}</b>
        </template>
      </hic-print-simple>
    </el-scrollbar>
    <div slot="footer">
      <el-button type="info" size="large" @click.native="$emit('update:visible', false)">关 闭</el-button>
    </div>
  </hic-dialog>
</template>

<script>
import { mapGetters } from "sw-hic";
export default {
  components: {},
  props: {
    visible: Boolean,
    hospitalization: Object,
    advices: Array,
    type: String,
  },
  data() {
    return {
      printData: {},
    };
  },
  computed: {
    ...mapGetters(["dict"]),
    tmplCode() {
      return this.type == "检验条码" ? "JianYanTiaoMa" : "JianYanShenQingDan";
    },
  },
  methods: {
    open() {
      this.loadData();
    },
    close() {
      this.$emit("update:visible", false);
    },
    loadData() {
      let deptName = this.$utils.Dict.text(this.advices[0].deptCode, "Dept");
      let patientGender = this.$utils.Dict.text(this.hospitalization.patientGender, "Gender");
      let patientAge = this.hospitalization.patientAge;
      if (this.type == "检验条码") {
        let detail = JSON.parse(this.advices[0].detail || "{}");
        this.printData = {
          Master: {
            deptName,
            patientGender,
            patientAge,
            ...this.advices[0],
            itemCode: this.advices[0].code,
            itemName: this.advices.reduce((txt, item) => txt + item.name + "；", "").slice(0, -1),
            tubeType: this.$utils.Dict.text(detail.tubeType, "BloodTubeType"),
          },
          Detail: [],
        };
        return;
      }
      this.printData = {
        Master: {
          deptName,
          patientGender,
          patientAge,
          ...this.advices[0],
        },
        Detail: this.advices.map((item) => ({
          ...item,
          specimen: this.getSpecimen(item),
        })),
      };
    },
    getSpecimen(item) {
      console.log(item)
      if (item.specimenType) {
        return this.$utils.Dict.text(item.specimenType, "SpecimenType");
      }
      if (item.detail) {
        try {
          let detail = JSON.parse(item.detail || "{}");
          console.log(detail);
          return this.$utils.Dict.text(detail.specimenType, "SpecimenType");
        } catch (e) {
          console.log(e);
        }
      }
      return "";
    },
  },
};
</script>
